import $ from 'jquery'

export default {
  init() {
    console.log('espace adhérent')
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/espace-adherent.js